import axios from'axios';

var root = process.env.API_ROOT;
// 添加一个新的axios实例

const $http = axios.create({
  baseURL:root,
  headers: {
    'Content-Type': 'application/json; charset=utf-8'
  }
});
// 添加请求拦截器
$http.interceptors.request.use(function (config) {

  // config.headers.Authorization = 'Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJhdXRvMCIsImZ1c2VySWQiOjR9.hs3-n6CPyhRBt4QrtH5dEVnPdUuXpw8nfCD9Nx8VSH4'

  //axios get请求不允许加"Content-Type",插件本身的bug 解决如下：
  if (config.method == 'get') {
    config.data = true;
    return config;
  }

  return config;
}, function (error) {
  // 对请求错误做些什么
  return Promise.reject(error);
});
export default $http;



// WEBPACK FOOTER //
// ./static/js/commonAxios.js